import React from 'react';
import { injectIntl  } from 'react-intl';
import { i18nIntl, isDesktop, isNotEmpty, stageSorting } from '../../lib/ep.js';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';

import MyNetsButtons from '../front/MyNetsButtons';
import ShareButton from '../front/buttons/ShareButton';
import VideoEmbed from '../front/VideoEmbed';

import StageMosaic from '../front/StageMosaic';
import LeveledHTMLText from '../front/helpers/LeveledHTMLText.js';
import { SuccessMessage } from '../builder/Message.js';
import EarnedPointsMessage from '../front/loyalty/EarnedPointsMessage.js';
import GoBackButton from '../front/buttons/GoBackButton.js';

const SuccessFlex = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props.promotion;
	const stage = props?.stage?.Stage ?? null;
	const user = props?.user ?? {};

	const is_builder = props?.is_builder ?? false;

	const has_ranking = promotion?.has_ranking ?? false;
	const public_entries = (isNotEmpty(promotion, 'public_entries', ['', '0', 0])) ? promotion.public_entries : false;
	const showUserParticipationButton = (public_entries && !has_ranking) ? promotion.public_entries : false;

	const display_my_participation = false;
	const display_go_mosaic = false;

	/*const display_go_mosaic = promotion?.is_multistage ?? false;
	let display_my_participation = promotion?.multi_participation ?? false;
	if(promotion.login_type == '3') display_my_participation = false;*/

	let has_final_link = false;
	let final_link = '';
	if(promotion.coupon_link != undefined && promotion.coupon_link != '') {
		has_final_link = true;

		//let url_uid = [`epfbuid=${user.id}`];
		let url_uid = []
		const get_operator = (promotion.coupon_link.indexOf("?") == -1) ? '?' : '&';
		final_link = promotion.coupon_link + get_operator + url_uid.join('&');
	}

	const coupon_label = (isNotEmpty(promotion, 'coupon_link_label')) ? promotion.coupon_link_label : i18n("Click here");

	const default_thanks_text = `<h1>${i18n("Thank you!")}</h1><p>${i18n("Share it now with your friends so they can enter too.")}</p>`;

	//Define the final message
	let final_message = (promotion.thanks_text != "") ? promotion.thanks_text : default_thanks_text;

	let final_image = false;
	let final_video = false;

	if(promotion.coupon != "") final_image = promotion.full_coupon;
	if(promotion.thankyou_video != "") final_video = promotion.thankyou_video;

	const display_loyalty_points_msg = props?.display_loyalty_points_msg ?? false;

	let qr = null;
	//If there is a quiz_message override
	if(props.quiz_message) {
		qr = props?.quiz_message?.QuizResult ?? props.quiz_message;
		final_message =  (qr != null) ? (qr?.message ?? final_image) : final_image;

		if(qr.image != "") final_image = qr.full_image;
		if(qr.video != "") final_video = qr.video;

		final_message = final_message.replace('{{score}}', props.score);
	}

	const nonwinner = (props.nonwinner != undefined) ? props.nonwinner : false;
	if(nonwinner) {
		const default_nonwinner_text = `<h1>${i18n("Sorry!")}</h1><p>${i18n("You haven't won any prize.")}</p>`;
		final_message = (isNotEmpty(promotion.config, 'no_prize_text')) ? promotion.config.no_prize_text : default_nonwinner_text;
		
		if(isNotEmpty(promotion, 'no_prize_img')) {
			final_image = promotion.full_no_prize_img;
		}

		if(isNotEmpty(promotion, 'no_prize_video')) {
			final_image = false;
			final_video = promotion.no_prize_video;
		}
	}

	let display_fblike_plugin = false;
	let display_my_nets = false;
	if(promotion.my_networks != undefined && promotion.my_networks.sections != undefined && promotion.my_networks.sections[0].nets != undefined && (promotion?.display_mynets_on_success ?? false)) {
		display_my_nets = true;
	}

	if(!display_my_nets && promotion.created < '2018-08-09 00:00:00' && (promotion?.config?.facebook_page ?? false)) display_fblike_plugin = true;

	let entries_button_label = i18n((!promotion.has_ranking) ? "View all participants" : "Ranking");
	if(isNotEmpty((promotion?.custom_labels ?? {}), 'view_entries_button')) {
		entries_button_label = promotion.custom_labels.view_entries_button;
	}

	let finish_button_enabled = promotion?.config?.finish_button?.enable ?? false;
	if(finish_button_enabled == '0') finish_button_enabled = false;

	const next_stage_id = stage?.next_stage_id ?? false;
	const next_stage_link = (true) ? `#stages/${next_stage_id}/options` : `${window.public_url}promotions/participate/${next_stage_id}`;


	const disconnect_button = promotion?.config?.finish_button?.label ?? i18n("Thank you! I am done");
	stageSorting(props.stages, (promotion?.stages_mosaic_sort_mode ?? 'date'));

	const display_back_button = promotion?.success_show_button_back ?? false;

	return (
		<div class="layout_conts">
			{(user.public_entry != undefined && user.public_entry == '2') && (
				<SuccessMessage
					title={i18n("Your video has been uploaded successfully and it is being processed and validated for its publication.")}
					custom_title_content={true}
					title_component='strong'
					icon='knk-time'
					_class={{ other:'extra_msg_warning in_top gui_not_in_bottom_big' }}
				/>
			)}

			<div class="flex_cols">
				{(final_image || final_video) && (
					<div class="flex_col col_1">
						<div class="final_image_module success_media_flex">
							{(final_image) && (
								<img src={final_image} alt="" />
							)}

							{(final_video) && (
								<VideoEmbed
									video_url={final_video.full_url}
									video_thumb={final_video.image}
								/>
							)}
						</div>
					</div>
				)}

				<div class="flex_col col_2">
					<section class="mod_align_center gui_full_container main_contents_flex">
						<article id="success_contents" class="success_container gui_semi_container">
							<article class="success_status">
								<div class="thankyou_message">
									{(display_loyalty_points_msg) && (
										<EarnedPointsMessage
											promotion={{ Promotion:promotion }}
											loyalty={props.loyalty}
											is_builder={is_builder}
										/>
									)}

									<LeveledHTMLText
										_class={{ other:'gui_main_text_color_on_bg' }}
									>{final_message}</LeveledHTMLText>

									{(next_stage_id) && (
										<ul class="next_stage_button">
											<li class="enter flex_button gui_big_button custom_button">
												<ActionLink
													_href={next_stage_link}
													autotranslate={false}
												>{i18n("Next step")}</ActionLink>
											</li>
										</ul>
									)}


									{(finish_button_enabled) && (
										<ul class="finish_button">
											<li class="enter flex_button gui_big_button finish_button">
												<ActionLink
													onClick={() => props.userSignout()}
													autotranslate={false}
												>{disconnect_button}</ActionLink>
											</li>
										</ul>
									)}

									{(promotion?.stages_in_success ?? false) && (
										<article style={{order:5}}>
											<StageMosaic
												brackets={window.brackets}
												stages={props.stages}
												promo={promotion}
												is_builder={true}
											/>
										</article>
									)}

									{((promotion.confirm_to_publish && (user.public_entry == undefined || user.public_entry == '1')) || (has_final_link || promotion.show_quiz_global_stats || promotion.show_quiz_question_stats)) && (
										<ul class="main_final_actions mod_align_center">
											{(qr != undefined && qr.cta_url != undefined && qr.cta_url != '') && (
												<li class="gui_big_button flex_button custom_btn">
													<ActionButton
														_href={qr.cta_url}
														_fullclass=""
														_target="_blank"
													>{(qr.cta_label != undefined && qr.cta_label != "") ? qr.cta_label : "Click here"}</ActionButton>
												</li>
											)}

											{(!promotion.confirm_to_publish && (promotion?.config?.share?.status ?? '0') != '0') && (
												<li>
													<ShareButton
														is_builder={true}
														promotion={promotion}
														sharing_type='recruiting'
														sharing_page='success'
														is_mobile={(!isDesktop()) ? true : false}
													/>
												</li>
											)}

											{(has_final_link) && (
												<li class="gui_big_button flex_button custom_btn">
													<ActionButton
														_href={final_link}
														_fullclass=""
														_target="_blank"
													>{coupon_label}</ActionButton>
												</li>
											)}

											{(promotion.show_quiz_question_stats || promotion.show_quiz_global_stats != '0') && (
												<li>
													<ActionLink
														_fullclass='see_quiz_stats quiz_stats'
														autotranslate={false}
													>{(promotion.quiz_stats_link != undefined && promotion.quiz_stats_link != '') ? promotion.quiz_stats_link : i18n("View statistics")}</ActionLink>
												</li>
											)}

											
										</ul>
									)}
								</div>
							</article>

							{(showUserParticipationButton || public_entries || display_my_participation || display_go_mosaic || display_back_button) && (
								<div class="success_actions gui_main_text_color_on_bg">
									{(showUserParticipationButton) && (
										<div class="voteme_btn">
											<ActionLink
												icon='knk-voteme'
											>View your entry</ActionLink>
										</div>
									)}

									{(public_entries) && (
										<div class="entries_btn">
											<ActionLink
												icon='knk-entries'
											>{entries_button_label}</ActionLink>
										</div>
									)}

									{(display_my_participation) && (
										<div class="my_participation_btn">
											<ActionLink
												icon='knk-me'
											>My participation</ActionLink>
										</div>
									)}

									{(display_go_mosaic) && (
										<div class="home_btn">
											<ActionLink
												icon='knk-home'
											>Go to home page</ActionLink>
										</div>
									)}

									{(display_back_button) && (
										<div class="back_btn">
											<GoBackButton
												promotion={promotion}
												/>
										</div>
									)}
								</div>
							)}
						</article>

						{(display_my_nets) && (
							<article class="gui_social_networks_box mod_align_center">
								<span class="hb_secondaryFont">{(promotion.my_networks.sections[0].text != undefined && promotion.my_networks.sections[0].text != '') ? promotion.my_networks.sections[0].text : i18n("Follow us")}</span>

								<MyNetsButtons
									networks={promotion.my_networks.sections[0].nets}
									type="success"
								/>
							</article>
						)}

						{(display_fblike_plugin) && (
							<article class="gui_like_box">
								<span class="hb_mainColorText hb_secondaryFont">{i18n("Follow us on Facebook")}</span>
								<div id="page_like_box" class="fb-page" data-href={promotion.config.facebook_page} data-width="500" data-small-header="true" data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="true" data-show-posts="false"><div class="fb-xfbml-parse-ignore"><blockquote cite="https://www.facebook.com/facebook"><a href="https://www.facebook.com/facebook">Facebook</a></blockquote></div></div>
							</article>
						)}
						
					</section>
				</div>
			</div>
		</div>
	)
};

export default injectIntl(SuccessFlex);